import Tag from '../../tag/index';

export default class IssuanceTag extends Tag {
  constructor(tag = {}, url) {
    super(tag, url);

    this.count = tag.count;
    this.total = tag.total;
  }

  get displayName() {
    return this.name === null ? 'Без тега' : this.name;
  }
}
